import React from 'react';

const BasePayrollForm = ({
    formData,
    validationErrors,
    units,
    unitsLoading,
    unitsError,
    handleChange,
    fetchUnits,
    mode = 'add'
}) => {
    const isAddMode = mode === 'add';

    return (
        <div className="modal-body">
            <div className="mb-3">
                <label htmlFor="unit_id" className="form-label fw-medium">
                    Unit <span className="text-danger">*</span>
                </label>
                {unitsLoading ? (
                    <div className="d-flex align-items-center">
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="text-muted">Loading units...</span>
                    </div>
                ) : unitsError ? (
                    <div className="alert alert-danger py-2 mb-0">
                        <small>
                            <i className="bi bi-exclamation-triangle me-1"></i>
                            {unitsError}
                        </small>
                        <button
                            className="btn btn-sm btn-outline-danger ms-2"
                            onClick={fetchUnits}
                        >
                            Retry
                        </button>
                    </div>
                ) : units.length === 0 ? (
                    <div className="alert alert-warning py-2 mb-0">
                        <small>
                            <i className="bi bi-exclamation-triangle me-1"></i>
                            No units found. Please create units first.
                        </small>
                    </div>
                ) : (
                    <>
                        <select
                            className={`form-select ${validationErrors.unit_id ? 'is-invalid' : ''}`}
                            id="unit_id"
                            name="unit_id"
                            value={formData.unit_id}
                            onChange={handleChange}
                            required
                            disabled={units.length === 0}
                        >
                            <option value="">Select Unit</option>
                            {units.map(unit => (
                                <option key={unit.unit_id} value={unit.unit_id}>
                                    {unit.unit_name}
                                </option>
                            ))}
                        </select>
                        {validationErrors.unit_id && (
                            <div className="invalid-feedback">{validationErrors.unit_id}</div>
                        )}
                        <div className="form-text">
                            {units.length} unit(s) available for your company
                        </div>
                    </>
                )}
            </div>

            <div className="mb-3">
                <label htmlFor="month_year" className="form-label fw-medium">
                    Month-Year <span className="text-danger">*</span>
                </label>
                <input
                    type="month"
                    className={`form-control ${validationErrors.month_year ? 'is-invalid' : ''}`}
                    id="month_year"
                    name="month_year"
                    value={formData.month_year}
                    onChange={handleChange}
                    required
                    disabled={units.length === 0}
                />
                {validationErrors.month_year && (
                    <div className="invalid-feedback">{validationErrors.month_year}</div>
                )}
                <div className="form-text">Format: YYYY-MM</div>
            </div>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="from_date" className="form-label fw-medium">
                        From Date <span className="text-danger">*</span>
                    </label>
                    <input
                        type="date"
                        className={`form-control ${validationErrors.from_date ? 'is-invalid' : ''}`}
                        id="from_date"
                        name="from_date"
                        value={formData.from_date}
                        onChange={handleChange}
                        required
                        disabled={units.length === 0}
                    />
                    {validationErrors.from_date && (
                        <div className="invalid-feedback">{validationErrors.from_date}</div>
                    )}
                </div>

                <div className="col-md-6 mb-3">
                    <label htmlFor="to_date" className="form-label fw-medium">
                        To Date <span className="text-danger">*</span>
                    </label>
                    <input
                        type="date"
                        className={`form-control ${validationErrors.to_date ? 'is-invalid' : ''}`}
                        id="to_date"
                        name="to_date"
                        value={formData.to_date}
                        onChange={handleChange}
                        required
                        disabled={units.length === 0}
                    />
                    {validationErrors.to_date && (
                        <div className="invalid-feedback">{validationErrors.to_date}</div>
                    )}
                </div>
            </div>

            <div className="mb-3">
                <label htmlFor="status" className="form-label fw-medium">
                    Status
                </label>
                <select
                    className="form-select"
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    disabled={units.length === 0}
                >
                    <option value="Open">Open</option>
                    <option value="Processed">Processed</option>
                    <option value="Closed">Closed</option>
                </select>
                <div className="form-text">
                    {isAddMode ? 'Default status is "Open"' : 'Note: Only "Open" periods can be edited'}
                </div>
            </div>
        </div>
    );
};

export default BasePayrollForm;